import { AuthService } from 'src/app/core/auth/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  cargando = false;

  constructor(private router: Router, private auth: AuthService) {
    this.resetPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    this.auth.estaAutenticado('/home');
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      this.cargando = true;

      let email = this.resetPasswordForm.get('email').value;

      this.auth.resetearPassword(email).then((res) => {
        this.cargando = false;
      });
    }
  }
}
